import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
	XThemeForm,
	XSwitch,
	XThemeContainer,
	XThemeDetailsCards,
	XThemeInputText,
	XThemeRadio,
	XThemeSwitchBtn,
	XThemeButton,
	XThemeTable,
	XThemeTag,
	XTag,
	XForm,
	XShareButton,
} from '../../../../styles/GlobalThemeStyle';
import {
	Row,
	Col,
	Button,
	Input,
	notification,
	Flex,
	Space,
	Table,
	Form,
	Card,
} from 'antd';
import {
	XThemeTilesCard,
	XThemeVoiceAssCard,
	XThemeVoiceaAsistCard,
	XThemeVoiceAssSeeBtn,
	XThemeVoiceAssTable,
	XThemeVoiceAssTableCard,
	XThemeVoiceAssTitle,
	XThemeVoiceCreateCaseBtn,
	XThemeVoiceaAsistChartCard,
	XThemeVoiceaAssSearchBar,
	XThemeFitToScreen,
	XThemeFixBottom,
	XThemeVoiceaAsistChatCard,
	XThemeVACheckbox,
	XThemeVASubmitBTN,
	XVSLottie,
	XVSLottieWrapper,
	XThemeVSSetViewPort,
	XThemeVSScrollContainer,
	XThemeVSGenerateAL,
	XThemeHeaderBTN,
	XThemeVSDetailsCard,
	XThemeVSPara1,
	XThemeSentToTabs,
	XThemeVARadio,
	XThemeVAInputText,
	XThemeVATextArea,
	XThemeVSLottieThanks,
	XThemeVSShareBTN,
} from '../../VoiceAssistanceStyle';
import { CalendarOutlined, PlusCircleOutlined } from '@ant-design/icons';
import ThanksJson from '../../../../json/thanksNew1.json';
import Dragger from 'antd/es/upload/Dragger';
import moment from 'moment';

const VAAppealLetterDownload = (props) => {
	const {
		displayEmailContent,
		setDisplayFaxUpload,
		letterDownloaded,
		setDisplayEmailContent,
		displayFaxUpload,
		setLetterDownloaded,
		getDownloadSignedURL,
		setDownloadLoading,
		sendLetterLoading,
		setSendLetterLoading,
		editCase,
		id,
		handleEmailSend,
	} = props;

	return (
		<>
			<XThemeVSSetViewPort className="displyBlock">
				<XThemeVSScrollContainer>
					<Row gutter={[15, 15]}>
						<Col xs={24} className="mb-3">
							<XThemeVoiceAssTitle>
								Share Appeal Letter
							</XThemeVoiceAssTitle>
						</Col>
						<Col xs={24}>
							<XThemeVoiceAssTableCard>
								<div className="hasPadding">
									<Row
										gutter={[15, 15]}
										className="align-items-center"
									>
										<Col xs={24} sm={8} lg={8}>
											{displayEmailContent ? (
												<Card
													role="button"
													className="text-center shareModalActive"
													onClick={() => {
														setDisplayFaxUpload(
															false,
														);
														if (!letterDownloaded) {
															setDisplayEmailContent(
																true,
															);
														}
													}}
												>
													<img
														src="/images/envelope 1 copy.svg"
														style={{
															marginBottom: '8px',
														}}
														alt="envelope"
													/>
													<p className="m-0">
														Send Via Email
													</p>
												</Card>
											) : (
												<Card
													role="button"
													className="text-center shareModal"
													onClick={() => {
														setDisplayFaxUpload(
															false,
														);
														if (!letterDownloaded) {
															setDisplayEmailContent(
																true,
															);
														}
													}}
												>
													<img
														src="/images/envelope 1.svg"
														style={{
															marginBottom: '8px',
														}}
														alt="emvelope"
													/>
													<p className="m-0">
														Send Via Email
													</p>
												</Card>
											)}
										</Col>
										<Col xs={24} sm={8} lg={8}>
											{displayFaxUpload ? (
												<Card
													role="button"
													className="text-center shareModalActive"
													onClick={() => {
														setDisplayEmailContent(
															false,
														);
														setDisplayFaxUpload(
															true,
														);
														setLetterDownloaded(
															false,
														);
													}}
												>
													<img
														src="/images/fax-active.svg"
														style={{
															marginBottom: '8px',
															color: 'red',
														}}
														alt="fax"
													/>
													<p className="m-0">
														Share Via Fax
													</p>
												</Card>
											) : (
												<Card
													role="button"
													className="text-center shareModal"
													onClick={() => {
														setDisplayEmailContent(
															false,
														);
														setDisplayFaxUpload(
															true,
														);
														setLetterDownloaded(
															false,
														);
													}}
												>
													<img
														src="/images/fax 1.svg"
														style={{
															marginBottom: '8px',
														}}
														alt="fax"
													/>
													<p className="m-0">
														Share Via Fax
													</p>
												</Card>
											)}
										</Col>
										<Col xs={24} sm={8} lg={8}>
											<Card
												role="button"
												className="text-center shareModal"
												onClick={() => {
													setDisplayFaxUpload(false);
													setDisplayEmailContent(
														false,
													);
													getDownloadSignedURL();
													setDownloadLoading(true);
												}}
											>
												<img
													src="/images/download 1.svg"
													style={{
														marginBottom: '8px',
													}}
													alt="download"
												/>
												<p className="m-0">
													Download PDF
												</p>
											</Card>
										</Col>
									</Row>
									<Row gutter={[15, 15]}>
										<Col xs={24}>
											{displayFaxUpload ? (
												<div className="mt-3">
													<Dragger
														showUploadList={false}
													>
														<img
															src="/images/file-upload 1.svg"
															style={{
																marginBottom:
																	'8px',
															}}
															alt="file upload"
														/>
														<p
															style={{
																color: '#ACACAC',
																fontFamily:
																	'Poppins',
																fontSize:
																	'14px',
																fontStyle:
																	'normal',
																fontWeight:
																	'500',
																lineHeight:
																	'20px',
																letterSpacing:
																	'0.28px',
															}}
														>
															Upload
															Acknowledgement
														</p>
													</Dragger>
													<XForm.Item className="text-right mt-3">
														<XShareButton
															loading={
																sendLetterLoading
															}
															style={{
																background:
																	'#212226',
															}}
															onClick={() => {
																setSendLetterLoading(
																	true,
																);
																// setSuccessModal(
																// 	true,
																// );
																//!Remove this state on funtion call

																setLetterDownloaded(
																	false,
																);
																setDisplayEmailContent(
																	false,
																);
																// setDisplayFaxUpload(
																// 	false,
																// );

																editCase({
																	id: id,
																	appeal_status:
																		'sent',
																	appeal_status_updated_at:
																		moment(),
																});
																// navigate(-1);
															}}
														>
															Send
														</XShareButton>
													</XForm.Item>
												</div>
											) : (
												''
											)}
											{displayEmailContent &&
											letterDownloaded ? (
												<div className="mt-3">
													<p>
														The letter has been
														downloaded. Please
														ensure that you do not
														overlook attaching the
														document in the email
														you are about to send.
													</p>
													<XForm.Item className="text-right mt-3">
														<XShareButton
															loading={
																sendLetterLoading
															}
															style={{
																background:
																	'#212226',
															}}
															onClick={() => {
																setSendLetterLoading(
																	true,
																);
																handleEmailSend();
															}}
														>
															Send Email
														</XShareButton>
													</XForm.Item>
												</div>
											) : (
												''
											)}
										</Col>
									</Row>
								</div>
							</XThemeVoiceAssTableCard>
						</Col>
					</Row>
				</XThemeVSScrollContainer>
			</XThemeVSSetViewPort>
		</>
	);
};

export default VAAppealLetterDownload;
